import { useEffect } from "react";
import { Box, Typography, Divider, Grid, Paper } from "@mui/material";
import FormatCurrency from "../../../utils/FormatCurrency";
import { Card } from "./Card/Card";
import MethodGet from "../../../config/Service";

export const CheckoutOrders = ({
  total,
  setTotal,
  discount,
  setDiscount,
  couponDiscount,
  setCouponDiscount,
  shippingCost,
  setShippingCost,
  setIdBusiness,
  cart,
  sumaSubtotal,
  setAditional,
  setCouponId,
  setPoints,
  usuario,
}) => {

  // Función para calcular todos los valores del carrito (misma lógica que Cart)
  const calculateCheckoutTotals = () => {
    let subtotalOriginal = 0;
    let descuentoDirecto = 0;
    let subtotalSinDescuentoDirecto = 0;
    let subtotalConDescuentoDirecto = 0;

    cart?.forEach(item => {
      const precioOriginal = item.price * item.cantidad;
      subtotalOriginal += precioOriginal;

      // Si el producto tiene descuento directo (price_with_discount)
      if (item.price_with_discount > 0) {
        const precioConDescuentoDirecto = item.price_with_discount * item.cantidad;
        descuentoDirecto += precioOriginal - precioConDescuentoDirecto;
        subtotalConDescuentoDirecto += precioConDescuentoDirecto;
      } else {
        // Si no tiene descuento directo, se incluye en productos aplicables para reglas/cupón
        subtotalSinDescuentoDirecto += item.final_price;
      }
    });

    return {
      subtotalOriginal,
      descuentoDirecto,
      subtotalSinDescuentoDirecto, // Productos sin descuento directo
      subtotalConDescuentoDirecto  // Productos con descuento directo
    };
  };

  const totals = calculateCheckoutTotals();

  // Actualizar sumaSubtotal con el subtotal original
  sumaSubtotal = totals.subtotalSinDescuentoDirecto;


  // Ganancia de puntos
  const pointsEarned = Number((total * (usuario?.points_percentage ?? 0)) / 100);
  setPoints(pointsEarned);

  // Obtener descuento por reglas de negocio
  useEffect(() => {
    const url = `/distribucion/Discount/${sumaSubtotal}`;
    MethodGet(url)
      .then((res) => {
        setDiscount(res.data.discount || 0);
        setIdBusiness(res.data.id || null);
      })
      .catch((error) => {
        console.error("Error fetching discount:", error);
      });
  }, [sumaSubtotal]);

  // Obtener descuento por cupón
  useEffect(() => {
    const storedCoupon = localStorage.getItem("appliedCoupon");
    const { discount, id } = JSON.parse(storedCoupon) || {};
    setAditional(discount || 0);
    setCouponId(id || null);
    if (storedCoupon && discount !== undefined) {
      const couponValue = Number(discount) || 0;
      setCouponDiscount(couponValue);
    } else {
      setCouponDiscount(0);
    }
  }, [sumaSubtotal]);

  // Calcular total con descuentos aplicados correctamente
  useEffect(() => {
    // Descuento por reglas de negocio (solo aplica a productos sin descuento directo)
    const descuentoReglas = totals.subtotalSinDescuentoDirecto * (discount / 100);

    // Descuento por cupón (se aplica al subtotal después del descuento por reglas)
    const subtotalDespuesReglas = totals.subtotalSinDescuentoDirecto - descuentoReglas;
    const descuentoCupon = subtotalDespuesReglas * (couponDiscount / 100);

    // Total final: productos con descuento directo + productos sin descuento directo después de aplicar reglas y cupón
    const finalTotal = totals.subtotalConDescuentoDirecto + subtotalDespuesReglas - descuentoCupon;

    setTotal(finalTotal);
  }, [totals.subtotalSinDescuentoDirecto, totals.subtotalConDescuentoDirecto, discount, couponDiscount]);

  // Costo de envío
  useEffect(() => {
    if (total > 0 && total < 7999) {
      setShippingCost(200);
    } else if (total >= 8000) {
      setShippingCost(400);
    } else {
      setShippingCost(0);
    }
  }, [total]);

  // Cálculos para mostrar en la UI
  const descuentoReglas = totals.subtotalSinDescuentoDirecto * (discount / 100);
  const subtotalDespuesReglas = totals.subtotalSinDescuentoDirecto - descuentoReglas;
  const descuentoCupon = subtotalDespuesReglas * (couponDiscount / 100);

  return (
    <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant='h5' gutterBottom>
        Tu pedido
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Box sx={{ maxHeight: 450, overflowY: "auto" }}>
        {cart.map((order, index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Card order={order} />
          </Box>
        ))}
      </Box>

      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2}>
        {totals.subtotalSinDescuentoDirecto > 0 && (
          <>
            <Grid item xs={6}>
              <Typography variant='body1'>
                Subtotal productos sin descuento directo:
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign='right'>
              <Typography fontWeight='bold'>
                {FormatCurrency(totals.subtotalSinDescuentoDirecto)}
              </Typography>
            </Grid>
          </>
        )}



        {totals.subtotalConDescuentoDirecto > 0 && (
          <>
            <Grid item xs={6}>
              <Typography variant='body1'>
                Subtotal productos con descuento directo:
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign='right'>
              <Typography fontWeight='bold' >
                {FormatCurrency((totals.subtotalConDescuentoDirecto + totals.descuentoDirecto))}
              </Typography>
            </Grid>
          </>
        )}

        <Grid item xs={6}>
          <Typography variant='body1'>Subtotal Global:</Typography>
        </Grid>
        <Grid item xs={6} textAlign='right'>
          <Typography fontWeight='bold'>
            {FormatCurrency(totals.subtotalOriginal)}
          </Typography>
        </Grid>

        {totals.descuentoDirecto > 0 && (
          <>
            <Grid item xs={6}>
              <Typography variant='body1' sx={{ color: 'green' }}>
                Descuento directo:
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign='right'>
              <Typography fontWeight='bold' sx={{ color: 'green' }}>
                -{FormatCurrency(totals.descuentoDirecto)}
              </Typography>
            </Grid>
          </>
        )}
        {discount > 0 && totals.subtotalSinDescuentoDirecto > 0 && (
          <>
            <Grid item xs={6}>
              <Typography variant='body1' sx={{ color: 'green' }}>
                Descuento por reglas ({discount}%):
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign='right'>
              <Typography fontWeight='bold' sx={{ color: 'green' }}>
                -{FormatCurrency(descuentoReglas)}
              </Typography>
            </Grid>
          </>
        )}

        {couponDiscount > 0 && totals.subtotalSinDescuentoDirecto > 0 && (
          <>
            <Grid item xs={6}>
              <Typography variant='body1' sx={{ color: 'green' }}>
                Descuento por cupón ({couponDiscount}%):
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign='right'>
              <Typography fontWeight='bold' sx={{ color: 'green' }}>
                -{FormatCurrency(descuentoCupon)}
              </Typography>
            </Grid>
          </>
        )}



        <Grid item xs={6}>
          <Typography variant='body1'>Costo de envío:</Typography>
        </Grid>
        <Grid item xs={6} textAlign='right'>
          <Typography fontWeight='bold'>
            {FormatCurrency(shippingCost)}
          </Typography>
        </Grid>

        <Divider sx={{ gridColumn: 'span 2', my: 1 }} />

        <Grid item xs={6}>
          <Typography variant='h6'>Total:</Typography>
        </Grid>
        <Grid item xs={6} textAlign='right'>
          <Typography variant='h6' fontWeight='bold'>
            {FormatCurrency(total + shippingCost)}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography sx={{ color: "#801F56" }} variant='subtitle1'>
            Con esta compra obtienes: <b>{pointsEarned.toFixed(2)}</b> Puntos
            Merry Color
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};